import { render, staticRenderFns } from "./EnumDetail.vue?vue&type=template&id=336e174a&"
import script from "./EnumDetail.vue?vue&type=script&lang=ts&"
export * from "./EnumDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports